const initialState = () => ({
  page: 1,
  // The day the board shows (YYYY-MM-DD); "" means today.
  date: "",
  role: [],
  status: [],
  // Day total against working hours: "met" / "short" / "absent".
  target: [],
  is_active: "true",
  sort: "name_asc",
});

export default {
  namespaced: true,
  state: initialState(),

  mutations: {
    RESET_FILTERS(state) {
      Object.assign(state, initialState());
    },
  },
  actions: {
    resetFilters({ commit }) {
      commit("RESET_FILTERS");
    },
  },
  getters: {
    // Fresh copy of the filter defaults; used by filterChipsMixin's
    // dev coverage guard to detect applied-but-unregistered filters.
    getInitialFilters: () => initialState(),
    getFilters: (state) => {
      return state;
    },
  },
};
